import React from 'react';
import { ThemeProvider, BaseFontCss, RtlEmotionCacheProvider, styled } from '@pixel/core/styles';
import { createInternalTheme } from '../styles';
import Box from '@pixel/core/Box';
// const RootBoxBackground = styled(Box)(({ theme },: { theme: PixelTheme }) => ({
//   background: theme.palette.appBackground.main,
//   display: 'flex',
//   flex: 1,
//   minWidth: "10px",
// }));

const RootBoxBackground = styled(Box, {
  shouldForwardProp: props => props !== "displayFlex"
})(_ref => {
  let {
    theme,
    displayFlex
  } = _ref;
  return {
    background: theme.palette.appBackground.main,
    display: displayFlex ? 'flex' : 'block',
    flex: 1,
    minWidth: "10px"
  };
});
export const Root = _ref2 => {
  let {
    seed = "tm",
    displayFlex = true,
    omitBaselineCss = false,
    themeParams = {
      darkMode: false
    },
    sx = {},
    children = null
  } = _ref2;
  const theme = createInternalTheme(themeParams);
  //console.log("THEME", theme)
  //todo background: #F5F8FA; should come from the theme.palette.background.default something is wrong hard coding it for now
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(RtlEmotionCacheProvider, {
      seed: seed
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/React.createElement(BaseFontCss, {
      cssPrefix: seed,
      omitBaselineCss: omitBaselineCss,
      sx: {
        display: 'flex',
        flex: 1,
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement(RootBoxBackground, {
      displayFlex: displayFlex,
      "data-qa": "RootBoxBackground",
      sx: sx
    }, children))))
  );
};
export default Root;